export const SUCCESS_CODE = 200;
export const BAD_REQUEST_CODE = 400;
export const UNAUTHORIZED_ERROR_CODE = 401;
export const NOT_FOUND_CODE = 404;
export const NO_REGISTRATION_CODE = 202;
export const ALREADY_REGISTERED = 417;
export const EMAIL_UNVERIFIED = 405;
export const RESOURCE_CREATED = 201;
export const SERVER_ERROR = 500;